// extracted by mini-css-extract-plugin
module.exports = {"archidektOrange":"#fa890d","quantityBlue":"#698bc7","quantityGreen":"#1ebb6c","flex":"copyDeck_flex__1kHnp","modal":"copyDeck_modal__xJQvf","pulse":"copyDeck_pulse__ccmKw"};